<script>
  import { beforeUpdate, onMount } from "svelte";
  import { isLoggedIn, clearToken, getTokenAttr } from "./auth";
  import { Router, Route, Link, navigate } from "svelte-routing";
  import VendorRouter, { VendorList, VendorShow } from "./vendors";
  import VenueRouter, { VenueList, VenueShow } from "./venues";
  import PopupRouter, { PopupList, PopupShow, PopupEdit } from "./popups";
  import InvoiceRouter, { InvoiceList, InvoiceShow } from "./invoices";
  import SaleRouter, { SaleList } from "./sales";
  import OrderRouter, { OrderList } from "./orders";
  import UserRouter, {UserList, UserShow}from "./users";

  import TopAppBar, {
    Row,
    Section,
    Title,
    FixedAdjust,
    DenseFixedAdjust
  } from "@smui/top-app-bar";
  import Drawer, {
    AppContent,
    Content,
    Header,
    Title as DrawerTitle,
    Subtitle,
    Scrim
  } from "@smui/drawer";
  import Button, { Label } from "@smui/button";
  import IconButton, { Icon } from "@smui/icon-button";
  import H6 from "@smui/common/H6.svelte";

  import NavigationMenu from "./NavigationMenu.svelte";

  export let location;

  let tabs = [
    { resource: "vendors", icon: "local_dining" },
    { resource: "venues", icon: "business" },
    { resource: "popups", label: "Events", icon: "event" },
    { resource: "invoices", icon: "payment" },
    { resource: "sales", icon: "list_alt" },
    { resource: "orders", icon: "public" },
    { resource: "users", icon: "people" }
  ];

  export let url = "";
  let drawerOpen = false;
  let active = tabs[0];
  let title;
  let innerWidth;

  function toggleDrawer() {
    drawerOpen = !drawerOpen;
  }

  function go(loc) {
    console.log("go: ", loc);
    if (loc && loc.length) {
      active = loc.split("/").filter(w => w.length > 0)[0];
    }
    navigate(loc);
    drawerOpen = false;
  }

  beforeUpdate(() => {
    if (!isLoggedIn()) {
      navigate("/login");
    }
  });

  onMount(() => {
    if (isLoggedIn()) {
      let loc = "/vendors";
      if (location && location.href) {
        loc = location.pathname;
      }
      // console.log("Main.onMount....");
      //go(loc);
    }
  });

  $: useModal = innerWidth && innerWidth <= 1200;
</script>

<style>
  .drawer-container {
    position: relative;
    display: flex;
    overflow: hidden;
    border: 1px solid rgba(0, 0, 0, 0.1);
    z-index: 0;
  }

  .main-content {
    overflow: auto;
    height: 100%;
    margin: auto;
    min-width: 70vw;
    width: fit-content;
  }

  .header {
    margin: 0 10px;
  }

  .title {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 800px) {
    .main-content {
      margin: 0;
      padding: 0;
    }

    .drawer-container {
      border: 0;
    }
  }

  * :global(.mdc-drawer--modal, .mdc-drawer-scrim) {
    /* This is not needed for a page-wide modal. */
    position: absolute;
  }
  * :global(.app-content) {
    flex: auto;
    overflow: auto;
    position: relative;
    flex-grow: 1;
  }

  div.drawer-container :global(.fixed-drawer) {
    /* makes the border on the fixed menu resize properly */
    height: unset;
  }
</style>

<svelte:window bind:innerWidth />

{#if useModal}
  <Drawer variant="modal" bind:open={drawerOpen}>
    <Header>
      <DrawerTitle>Food Disco</DrawerTitle>
    </Header>
    <Content>
      <NavigationMenu
        bind:active
        items={tabs}
        on:navigate={e => go(e.detail)} />
    </Content>
  </Drawer>
  <Scrim />
{/if}

<TopAppBar dense variant="fixed" color="secondary">
  <Row>
    <Section>
      <IconButton
        on:click={toggleDrawer}
        class="material-icons burger"
        ripple={false}>
        menu
      </IconButton>
      <h2 class="title">{title || ''}</h2>
    </Section>

    <Section align="end">
      <h3 class="header">{getTokenAttr('username')}</h3>
    </Section>
  </Row>
</TopAppBar>

<div use:DenseFixedAdjust class="drawer-container">
  {#if !useModal}
    <Drawer variant="fixed" class="fixed-drawer">
      <Content>
        <NavigationMenu
          bind:active
          items={tabs}
          on:navigate={e => go(e.detail)} />
      </Content>
    </Drawer>
  {/if}
  <AppContent class="app-content">
    <main class="main-content">
      <Router {url}>
        <Route path="vendors">
          <VendorList {location} bind:title />
        </Route>
        <Route path="vendors/:id" let:params>
          <VendorShow {location} bind:title {...params} />
        </Route>
        <Route path="venues">
          <VenueList {location} bind:title />
        </Route>
        <Route path="venues/:id" let:params>
          <VenueShow {location} bind:title {...params} />
        </Route>
        <Route path="venues">
          <VenueList {location} bind:title />
        </Route>
        <Route path="venues/:id" let:params>
          <VenueShow {location} bind:title {...params} />
        </Route>
        <Route path="popups" let:params>
          <PopupList {location} bind:title {...params} />
        </Route>
        <Route path="popups/create" let:params>
          <PopupEdit {location} bind:title id="create" {...params} />
        </Route>
        <Route path="popups/:id/edit" let:params>
          <PopupEdit {location} bind:title {...params} />
        </Route>
        <Route path="popups/:id" let:params>
          <PopupShow {location} bind:title {...params} />
        </Route>
        <Route path="orders" let:location>
          <OrderList bind:title {location} />
        </Route>
        <Route path="invoices">
          <InvoiceList {location} bind:title />
        </Route>
        <Route path="invoices/:id" let:params>
          <InvoiceShow {location} bind:title {...params} />
        </Route>
        <Route path="sales" let:location>
          <SaleList bind:title {location} />
        </Route>
        <Route path="users">
          <UserList {location} bind:title />
        </Route>
        <Route path="users/:id" let:params>
          <UserShow {location} bind:title {...params} />
        </Route>
        <!-- Route path="vendors/*" let:location>
          <VendorRouter bind:title {location} />
        </Route>
        <Route path="venues/*" let:location>
          <VenueRouter bind:title {location} />
        </Route>
        <Route path="popups/*" let:location>
          <PopupRouter bind:title {location} />
        </Route>
        <Route path="invoices/*" let:location>
          <InvoiceRouter bind:title {location} />
        </Route>
        <Route path="sales/*" let:location>
          <SaleRouter bind:title {location} />
        </Route>
        <Route path="users/*" let:location>
          <UserRouter bind:title {location} />
        </Route-->
      </Router>
    </main>
  </AppContent>
</div>
